var exports = {
  "kL": "container__WydlWO",
  "R_": "heading__r2RuKO",
  "M0": "feedbackLink__LnMi91",
  "Vs": "feedbackText__v2iKKz",
};

module.exports = exports;
